<template>
  <div
    v-if="Object.keys(lt).length>0"
    id="25"
    class="jsBubble_s"
    :style="lt"
  >
    <div class="arrowL">
      <div
        class="arrowt"
        style="border-color:transparent #fff transparent transparent "
      ></div>
      <div
        class="arrowb"
        style="border-color:transparent #fff transparent transparent "
      ></div>
    </div>
    <div
      class="tipCon"
      style="background:#fff; border-color:#fff; padding-right:0px;"
    >
      <div
        class="tipTitle"
        style="background:#fff;border-bottom:1px solid #EFEFEF;"
      >批量添加选项
        <a
          href="javascript:;"
          class="jsTip_close"
        ></a>
      </div>
      <div class="tipCon_t">
        <div
          class="new_poplayer"
          qid="5c0dc85e92beb56096e210de"
        >
          <p>每行代表一个选项，可以添加多个选项</p>
          <div>
            <textarea
              v-model="val"
              class="bulkadd"
            ></textarea>
          </div>
          <div class="tool_bar">
            <span
              class="cancel"
              @click="$store.dispatch('setBubbleParameter', {})"
            >取消</span>
            <span
              name="2"
              type="row"
              class="save"
              @click="save"
            >保存</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uuid from "uuid";
export default {
  data() {
    return {
      timestamp: Date.parse(new Date()),
      val: ""
    };
  },
  computed: {
    lt: {
      get: function() {
        return this.$store.state.survey.bubbleParameter;
      },
      set: function() {}
    },
    qid: {
      get: function() {
        return this.$store.state.survey.activeQuestion.id;
      },
      set: function() {}
    }
  },
  watch: {
    lt: function() {
      this.val = "";
    }
  },
  methods: {
    save() {
      let arr = this.val.split(/[(\r\n)\r\n]+/);
      if (arr.indexOf("") >= 0) arr.splice(arr.indexOf(""), 1);
      let option = [];
      arr.forEach(item => {
        option.push({
          id: uuid(this.timestamp),
          text: item,
          setting: {
            show: false,
            text: "",
            required: true,
            validate: ""
          }
        });
      });
      const data = {
        id: this.qid,
        option: option
      };
      this.$store.dispatch("addOption", data);
      this.val = "";
      this.$store.dispatch("setBubbleParameter", {});
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.jsBubble_s {
  border-radius: 4px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  padding: 0 24px;
  background-color: #fff;
  position: absolute;
  min-width: 50px;
  width: 500px;
  z-index: 99;

  .arrowL {
    position: absolute;
    font-size: 30px !important;
    z-index: 9900;
    width: 30px;
    border-bottom: none !important;
    left: -14px;
    top: 7px;

    .arrowt {
      border-width: 7px;
      border-style: dashed solid dashed dashed;
      border-color: transparent #f3f3f3 transparent transparent;
      z-index: 3;
      left: 1px;
    }

    .arrowb {
      border-width: 7px;
      border-style: dashed solid dashed dashed;
    }

    .arrowt,
    .arrowb {
      font: 0px/9999px serif;
      height: 0;
      overflow: hidden;
      position: absolute;
      width: 0;
      z-index: 1;
      width: 0px;
      height: 0px;
      color: inherit;
    }
  }

  .tipCon {
    background: #fff;
    border-color: #fff;
    padding-right: 0px;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-size: 12px;
    overflow: visible;

    .tipTitle {
      border: none !important;
      padding: 24px 0 0;
      line-height: 25px;
      font-size: 18px;
      color: #484848;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      background: #fff;
    }

    .tipCon_t {
      padding: 0;
      z-index: 1002;
      overflow: auto;

      .new_poplayer {
        textarea {
          width: 100%;
          box-sizing: border-box;
          padding: 10px;
          height: 150px;
          border-radius: 2px;
          background-color: #ffffff;
          border: solid 1px #aaaaaa;
          font-size: 14px;
          color: #484848;
          line-height: 20px;
          resize: none;
        }

        p {
          padding: 12px 0;
          width: 252px;
          height: 20px;
          font-size: 14px;
          color: #484848;
        }

        .tool_bar {
          padding: 24px 0;
          text-align: right;

          span {
            display: inline-block;
            width: 96px;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            text-align: center;
            cursor: pointer;
          }

          span.cancel {
            width: 94px;
            height: 34px;
            line-height: 34px;
            border: 1px solid #aaa;
            color: #484848;
          }

          span.save {
            background-color: @deepblue;
            color: #fff;
            margin-left: 5px;
          }
        }
      }
    }
  }
}
</style>
